import React, { FC } from 'react'

import { IconPublicWifiProps } from './IconPublicWifi.types'
import * as Styled from './styles/IconPublicWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPublicWifi: FC<IconPublicWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPublicWifiProps['size'],
  isResponsive = false,
}: IconPublicWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M42.292 17.795c-.5-.5-1.737-1.5-3.317-2.713V5.125h-4.928a3.235 3.235 0 0 0-3.225 3.222v.63C28.67 7.395 27.087 6.25 27.087 6.25c-2.285-1.818-4.25-1.405-6.037 0 0 0-13.775 10.203-15.205 11.547-2.218 2.085.335 5.228 3.017 5.228h1.2v15.91a4.015 4.015 0 0 0 4 4h20a4 4 0 0 0 4-4v-15.91h1.21c2.685 0 4.92-3.33 3.02-5.23Z'
          stroke='#fff'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M20.57 27.293a4.938 4.938 0 0 1 6.982 0M17.077 23.8a9.877 9.877 0 0 1 13.97 0m-6.985 7.293a.308.308 0 1 0 0-.615.308.308 0 0 0 0 .615Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24.832 30.785a.77.77 0 1 1-1.54 0 .77.77 0 0 1 1.54 0Z' fill='#EA1A1A' stroke='#EA1A1A' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPublicWifi
